var _title, _desc, _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgWindSheeld = _ref => {
  let svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "20px",
    viewBox: "0 0 25 20",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "langu skystis")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Uzsakymai",
    transform: "translate(-1228.000000, -175.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "langu-skystis",
    transform: "translate(1229.000000, 176.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7204679,17.9017476 C16.5282255,16.6757427 14.1545732,16.0627403 11.5995109,16.0627403 C9.04444874,16.0627403 6.58382709,16.6757427 4.217646,17.9017476 L1.9069727,11.4473491 C2.96666268,11.7799434 3.91191302,11.9462405 4.74272371,11.9462405 C5.98893975,11.9462405 6.45018878,11.3255508 7.71856523,11.3255508 C8.98694168,11.3255508 8.88240304,11.9462405 10.1702958,11.9462405 C11.4581886,11.9462405 11.5503899,11.3255508 12.8651582,11.3255508 C14.1799265,11.3255508 14.1660947,11.9462405 15.4321043,11.9462405 C16.6981139,11.9462405 16.6537389,11.3255508 17.9305561,11.3255508 C18.7817675,11.3255508 19.8167379,11.6452961 21.0354675,12.2847866 L18.7204679,17.9017476 Z",
    id: "Path-5",
    fill: "#464648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.327293299,9.74853044 L3.94219585,17.3244724 C4.09402858,17.6425818 4.46376414,17.7919641 4.79394624,17.6685681 C6.60070059,16.993346 8.83687998,16.655735 11.5024844,16.655735 C14.192189,16.655735 16.4981156,16.9994784 18.420264,17.6869653 C18.7438455,17.802763 19.1029394,17.6588792 19.2570872,17.3517106 L23.0652585,9.76320937 C23.2337696,9.42754804 23.0982047,9.01885639 22.7625174,8.85039696 C22.7320284,8.83509651 22.7004313,8.82211181 22.6679938,8.81155282 C18.8316634,7.56275965 15.1421691,6.93836306 11.5995109,6.93836306 C8.05712983,6.93836306 4.4319525,7.56266199 0.723978955,8.81125985 C0.368084216,8.93112903 0.176720837,9.31679855 0.296565227,9.67270164 C0.305276563,9.69857178 0.315537825,9.72389388 0.327293299,9.74853044 Z",
    id: "Path-2",
    stroke: "#464648",
    strokeWidth: 1.44
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.708423,12.690081 L11.6926608,1.751145",
    id: "Path-3",
    stroke: "#464648",
    strokeWidth: 1.44
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.02511094,4.69870168 C2.52364138,2.34019234 3.82842797,0.847134625 5.93947071,0.219528543 C8.05051345,-0.408077539 9.96943597,0.310004923 11.6962383,2.37377593",
    id: "Path-4",
    stroke: "#464648",
    strokeWidth: 1.44,
    strokeDasharray: "3.4,0.6800000190734864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5995109,4.69870168 C12.0980414,2.34019234 13.402828,0.847134625 15.5138707,0.219528543 C17.6249134,-0.408077539 19.543836,0.310004923 21.2706383,2.37377593",
    id: "Path-4-Copy",
    stroke: "#464648",
    strokeWidth: 1.44,
    strokeDasharray: "3.4,0.6800000190734864",
    transform: "translate(16.435075, 2.349351) scale(-1, 1) translate(-16.435075, -2.349351) "
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWindSheeld, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/windSheeld.55344641.svg";
export { ForwardRef as ReactComponent };